import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-open',
  templateUrl: './icon-open.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconOpenComponent {}
